let enableAllFeatures = false;

export function setFeatures(enable) {
    if (enable !== undefined) {
        enableAllFeatures = enable;
    }
}
export function getFeatures() {
    return enableAllFeatures;
}